define('modules/lp_info/views/edit_variant_popup',['require','exports','module','common/views/modal_view','ldsh!../templates/create_variant_popup'],function(require, exports, module) {
  "use strict";

  var ModalView = require("common/views/modal_view");

  module.exports = ModalView.extend({
    template: require("ldsh!../templates/create_variant_popup"),
    triggers: {
      "click .js-save": "save",
      "click .js-cancel": "cancel"
    },
    initialize: function(options){
      this.variants = options.variants;
      if(!this.variants){
        throw new Error("Create Variant popup needs a reference to the variant collection!");
      }
      this.listenTo(this.variants, "sync", this._updateCreateOptions);
    },
    getData: function() {
      var mode = this.$(".js-mode input:checked").val(),
          name = this.$(".js-name").val();

      if(!name) {
        this.$(".js-name-group").addClass("has-error");
        this.$(".js-name-error").removeClass("hidden");
        return undefined;
      }
      else {
        this.$(".js-name-group").removeClass("has-error");
        this.$(".js-name-error").addClass("hidden");
      }
      return {
        name: this.$(".js-name").val(),
        duplicateMain: mode === "duplicate",
        crossPlatform: !!this.$(".js-copy-dual input:checked").val()
      };
    },
    _updateCreateOptions: function(){
      var mainVariant = this.variants.getMainFor(this.model.get("mode"));
      this.$(".js-duplicate-variant").toggle(mainVariant !== undefined);
      this.$(".js-copy-dual").toggle(mainVariant === undefined);
    },
    onRender: function(){
      this._updateCreateOptions();
      this.$el.i18n();
    }
  }, {
    show: function(newVariant, variantCollection) {
      var popup = new module.exports({model: newVariant, variants: variantCollection}),
          defer = new $.Deferred();

      popup.on("save", function() {
        var data = this.getData();
        if(data) {
          defer.resolve(data);
          this.hide();
        }
      });
      popup.on("cancel hide", defer.reject, defer);
      popup.on("save cancel", popup.hide, popup);
      return defer.promise();
    }
  });

});

